import angular, { IScope } from 'angular';
import { InterfaceService } from '../../shared/interface/interface.service';
import { UsersService } from '../../shared/users/users.service';
import { Role, User } from '../../src/app/@shared-types/user';

import './user-select.style.scss';

export const UserSelectComponent = {
  selector: 'userSelect',
  restrict: 'E',
  bindings: {
    selectedItems: '=',
    selectedItemsChange: '&',
    type: '@',
    initSelection: '@',
  },
  template: /* html */`
    <div class="user-select">
      <div class="selected-items">
        <div class="chip" ng-repeat="item in $ctrl.search.selectedItems track by $index" ng-click="$ctrl.selectItem(item.id)">
          <div class="icon">
            <profile-image user-id="item.id" ng-if="type === 'users'"></profile-image>
          </div>
          <span ng-if="$ctrl.type === 'users'">{{item.first_name}} {{item.last_name}}</span>
          <span ng-if="$ctrl.type === 'roles'">{{item.name}}</span>
          <div class="icon">
            <svg class="ab-icon"><use xlink:href="#btn-times"></use></svg>
          </div>
        </div>
      </div>

      <div class="btn-wrap">
        <button type="button" class="btn-lvl3 left" ng-click="$ctrl.openOverlay()" ng-if="$ctrl.type === 'users'">
          <svg class="ab-icon"><use xlink:href="#btn-add"></use></svg> Benutzer hinzufügen
        </button>

        <button type="button" class="btn-lvl3 left" ng-click="$ctrl.openOverlay()" ng-if="$ctrl.type === 'roles'">
          <svg class="ab-icon"><use xlink:href="#btn-add"></use></svg> Benutzergruppe hinzufügen
        </button>
      </div>


      <div class="overlay" ng-show="$ctrl.showOverlay">
        <div class="overlay-background" ng-click="$ctrl.hideOverlay()"></div>

        <div class="overlay_inner">
          <h3 ng-if="$ctrl.type === 'users'">Benutzer auswählen</h3>
          <h3 ng-if="$ctrl.type === 'roles'">Benutzer auswählen</h3>

          <input type="text" ng-model="$ctrl.search.phrase" placeholder="Benutzer suchen" ng-keyup="$ctrl.filterItems()" ng-if="type === 'users'">
          <input type="text" ng-model="$ctrl.search.phrase" placeholder="Rolle suchen" ng-keyup="$ctrl.filterItems()" ng-if="type === 'roles'">

          <ul>
            <li ng-repeat="option in $ctrl.search.filteredOptions track by $index" ng-click="$ctrl.selectItem(option.id)" ng-show="!$ctrl.option.hidden">
              <div class="row">
                <div class="col-2">
                  <profile-image user-id="{{ option.id }}" ng-if="$ctrl.type === 'users'"></profile-image>
                </div>
                <div class="col-8">
                  <div ng-if="$ctrl.type === 'users'">
                    <span>{{option.first_name}} {{option.last_name}}</span>
                    <span>{{option.email}}</span>
                  </div>
                  <div ng-if="$ctrl.type === 'roles'">
                    <span>{{option.name}}</span>
                    <span>{{option.description}}</span>
                  </div>
                </div>
                <div class="col-2">
                  <div class="selected-icon" ng-if="option.selected">
                    <svg class="ab-icon"><use xlink:href="#checkbox-checked"></use></svg>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <div class="btn-wrap">
            <button type="button" class="btn-lvl3" ng-click="$ctrl.closeOverlay()">Schließen</button>
          </div>
        </div>
      </div>
    </div>
  `,
  controller: class UserSelectController {
    private selectedItems!: string;

    private selectedItemsChange!: (event: string | { $event: string }) => void;

    private type?: 'roles' | 'users';

    private initSelection?: string;

    private options: User[] | Role[] = [];

    private interfaceService: InterfaceService;

    private $scope: IScope;

    private search: {
      phrase: string,
      filteredOptions: User[] | Role[],
      selectedItems: User[] | Role[],
    };

    private showOverlay = false;

    private usersService: UsersService;

    constructor(
      $scope: IScope,
      interfaceService: InterfaceService,
      usersService: UsersService,
    ) {
      'ngInject';

      this.interfaceService = interfaceService;
      this.usersService = usersService;
      this.$scope = $scope;

      this.search = {
        filteredOptions: [],
        phrase: '',
        selectedItems: [],
      };

      this.selectedItems = '';
    }

    $onInit(): Promise<void> | void {
      if (this.type === 'roles') return this.initRoleSelection();
      return this.initUserSelection();
    }

    private initRoleSelection = async (): Promise<void> => {
      const roles = await this.usersService.getRoles();
      this.options = roles;
      this.preSelectItems();
    };

    private initUserSelection = (): void => {
      this.type = 'users';
      this.options = this.usersService.getUsers()
      // eslint-disable-next-line prefer-object-spread
        .map((u) => Object.assign({}, (u as User)))
        .sort((a, b) => a.first_name.localeCompare(b.first_name));

      this.preSelectItems();
    };

    private preSelectItems = () => {
      if (this.initSelection) {
        for (const id of this.initSelection.split(',')) {
          this.selectItem(parseInt(id, 10));
        }
      }

      this.interfaceService.applyScope(this.$scope);
    };

    public openOverlay = (): void => {
      this.search.phrase = '';
      this.search.filteredOptions = this.options;
      this.showOverlay = true;
    };

    public closeOverlay = (): void => {
      this.showOverlay = false;
    };

    public filterItems = (): void => {
      this.search.filteredOptions = this.options;
      for (const o of this.search.filteredOptions) {
        let searchString: string;

        if (this.type === 'roles') {
          searchString = (o as Role).name;
        } else {
          searchString = (`${(o as User).first_name} ${(o as User).last_name}`).toLowerCase();
        }

        (o as any).hidden = false;
        if (!searchString.includes(this.search.phrase.toLowerCase())) (o as any).hidden = true;
      }

      this.interfaceService.applyScope(this.$scope);
    };

    private returnSelectedItems = (): void => {
      const items = [];
      this.search.selectedItems = [];
      const selectedItems = (this.options as any[]).filter((o) => o.selected);

      for (const i of selectedItems) {
        items.push(i.id);
        this.search.selectedItems.push(i);
      }

      this.selectedItems = items.join(',');
      this.selectedItemsChange({ $event: items.join(',') });
    };

    public selectItem = (id: number): void => {
      const selectedItem = (this.options as any).find((i: any) => i.id === id);
      selectedItem.selected = !selectedItem.selected;
      this.returnSelectedItems();
    };
  },
};

export default angular.module('autoboard.userSelect', [])
  .component(UserSelectComponent.selector, UserSelectComponent)
  .name;
